export default "__VITE_ASSET__CjEpFISp__"